export default __webpack_public_path__ + "static/media/BANQUETES.c84c0607.jpg";